
function globalJsTranslations(){
	function getAlltranslations(){
		if (typeof global_js_trans == 'undefined') {
			return false;
		}
		
		return global_js_trans;
	}
	
	function getTrans(val){
		if (typeof global_js_trans == 'undefined') {
			return false;
		}
		if (typeof val == "undefined" || val == '') {
			return false;
		}
		if (typeof global_js_trans[val] == "undefined" ) {
			return false;
		}
		return global_js_trans[val];
	}
	
	return {
		getAll: getAlltranslations,
		getTr: getTrans
	};
}

export {globalJsTranslations};